// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
    background-color: #f8f9fa;
    padding: 20px 0;
    margin-top: auto;
}

.social-btn {
    transition: transform 0.2s;
}

.social-btn:hover {
    transform: scale(1.1);
}

.social-btn.rewarded {
    opacity: 0.8;
    cursor: default;
}

.check-badge {
    position: absolute;
    top: -5px;
    right: -5px;
    background: white;
    border-radius: 50%;
    width: 16px;
    height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}`, "",{"version":3,"sources":["webpack://./src/components/Footer.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,wCAAwC;AAC5C","sourcesContent":[".footer {\r\n    background-color: #f8f9fa;\r\n    padding: 20px 0;\r\n    margin-top: auto;\r\n}\r\n\r\n.social-btn {\r\n    transition: transform 0.2s;\r\n}\r\n\r\n.social-btn:hover {\r\n    transform: scale(1.1);\r\n}\r\n\r\n.social-btn.rewarded {\r\n    opacity: 0.8;\r\n    cursor: default;\r\n}\r\n\r\n.check-badge {\r\n    position: absolute;\r\n    top: -5px;\r\n    right: -5px;\r\n    background: white;\r\n    border-radius: 50%;\r\n    width: 16px;\r\n    height: 16px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
